import { render, staticRenderFns } from "./workgroupForm.vue?vue&type=template&id=4b81df62&scoped=true&%23default=true&"
import script from "./workgroupForm.vue?vue&type=script&lang=js&"
export * from "./workgroupForm.vue?vue&type=script&lang=js&"
import style0 from "./workgroupForm.vue?vue&type=style&index=0&id=4b81df62&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b81df62",
  null
  
)

export default component.exports